import { ErrorHandler } from '@angular/core';

export class AppErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any) {
    alert('An unexpected error occured.');
    console.log(error);
  }
}
